module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=KE - Kenya.5a4230b5.svg";